import React from "react";
import { ConfigProvider, DatePicker } from "antd";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const THEME = { token: { colorPrimary: "#fb310d", borderRadius: 8, fontFamily: "inherit", controlHeight: 38 } };
const ISO = "YYYY-MM-DD";

export const rangeOfPicker = (values) =>
  values && values[0] && values[1] ? { from: values[0].format(ISO), to: values[1].format(ISO) } : null;

const pickerOfRange = (range) => (range ? [dayjs(range.from), dayjs(range.to)] : null);

export const rangePresets = (today = dayjs()) => {
  const yesterday = today.subtract(1, "day");
  const lastMonth = today.subtract(1, "month");
  return [
    { label: "Today", value: [today, today] },
    { label: "Yesterday", value: [yesterday, yesterday] },
    { label: "Last 7 days", value: [today.subtract(6, "day"), today] },
    { label: "This month", value: [today.startOf("month"), today] },
    { label: "Last month", value: [lastMonth.startOf("month"), lastMonth.endOf("month")] },
  ];
};

export default function DateRangeField({ label, value, onChange, allowClear = true, popupZIndex }) {
  const today = dayjs();
  return (
    <ConfigProvider theme={THEME}>
      <RangePicker
        value={pickerOfRange(value)}
        onChange={(values) => onChange(rangeOfPicker(values))}
        format="DD/MM/YYYY"
        presets={rangePresets(today)}
        disabledDate={(day) => day.isAfter(today, "day")}
        allowClear={allowClear}
        placeholder={["From", "To"]}
        aria-label={label}
        styles={popupZIndex ? { popup: { root: { zIndex: popupZIndex } } } : undefined}
      />
    </ConfigProvider>
  );
}
